import {
  defaultGroupedFilter,
  GroupedFilter,
} from 'module/types/filter-field/grouped-filter/filter';
import { FilterGroupType } from 'module/types/filter-field/grouped-filter/group';
import { PageType } from 'api/page-template/types';

/**
 * Same list filter as page-level meeting/email previews: use page trigger
 * condition when set, otherwise the default grouped filter for that source.
 */
export function resolvePageTriggerListFilter(
  pageType: string | undefined,
  pageTriggerCondition?: GroupedFilter | null,
): GroupedFilter | undefined {
  if (pageType === PageType.Meeting) {
    return (
      pageTriggerCondition ?? defaultGroupedFilter(FilterGroupType.Meeting)
    );
  }

  if (pageType === PageType.Email) {
    return pageTriggerCondition ?? defaultGroupedFilter(FilterGroupType.Email);
  }

  return undefined;
}
